import * as React from 'react';

import type {DueDateUnit as DelayUnit, Delay} from 'nutshell-core/types';

import {ButtonCard} from '../card/button-card';
import {DelayBar} from '../delay-bar/delay-bar';
import type {DripEditionStatus} from '../edition/get-edition-status-info';

import styles from './map-thumbnail-card.module.css';

export type Props = {
    id: string;
    name: string;
    isSelected: boolean;
    thumbnailUrl?: string;
    delay:
        | {
              unit: DelayUnit;
              timespan: number;
          }
        | null
        | undefined;
    status?: DripEditionStatus;
    onSelectMessage: (editionId: string) => void;
    onUpdateEdition: (arg1: {editionId: string; delay: Delay}) => Promise<any>;
    backgroundColor: string;
    previewComponent: React.ReactNode | null | undefined;
};

export function MapThumbnailCard(props: Props) {
    return (
        <React.Fragment>
            {props.delay ? (
                <DelayBar
                    delay={props.delay}
                    isSmall={true}
                    // Only draft edition delays can be edited from this page
                    isEditable={props.status === 'NEW'}
                    saveChanges={(unit: DelayUnit, timespan: number) =>
                        props.onUpdateEdition({editionId: props.id, delay: {unit, timespan}})
                    }
                    editionId={props.id}
                />
            ) : null}
            <div className={styles['thumbnail-card-wrapper']}>
                <ButtonCard
                    fitHeight={true}
                    isSelected={props.isSelected}
                    onClick={() => props.onSelectMessage(props.id)}
                >
                    <div
                        style={{backgroundColor: props.backgroundColor}}
                        className={styles['image-container']}
                    >
                        {!props.thumbnailUrl && props.previewComponent ? (
                            props.previewComponent
                        ) : (
                            <img
                                className='full-width'
                                src={props.thumbnailUrl}
                                alt={`Thumbnail for ${props.name}`}
                            />
                        )}
                    </div>
                    <div className={styles['name-container']}>
                        <p className={styles.name}>{props.name}</p>
                    </div>
                </ButtonCard>
            </div>
        </React.Fragment>
    );
}
